import './EOL.scss';

const EOL = () => {
  return <div className="EOL">End of list</div>;
};

export default EOL;
